import { render } from "./AggregatedReportSettings.vue?vue&type=template&id=0ada5dc9"
import script from "./AggregatedReportSettings.vue?vue&type=script&lang=js"
export * from "./AggregatedReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__